'use client';

import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import { useState, useEffect, ReactNode } from 'react';
import CustomRichText from '../CustomRichText';

export interface StudyFormatBlockProps {
  title: ReactNode | SerializedEditorState;
  subtitle: ReactNode | SerializedEditorState;
  txtContent: ReactNode | SerializedEditorState;
  list: Array<string> | Array<{ item: ReactNode | SerializedEditorState }>;
  index: number;
  color: 'violet' | 'green' | 'blue';
}
export default function StudyFormatCardVioletV2({
  title,
  subtitle,
  txtContent,
  index,
  list,
  color,
}: StudyFormatBlockProps) {
  const [isHovered, setIsHovered] = useState(false);
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    // Перевіряємо, чи пристрій є сенсорним
    const checkTouchDevice = () => {
      if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
        setIsTouchDevice(true);
      }
    };

    checkTouchDevice();

    // Додаємо слухач для зміни розміру екрана
    window.addEventListener('resize', checkTouchDevice);

    return () => {
      window.removeEventListener('resize', checkTouchDevice);
    };
  }, []);

  const handleMouseEnter = () => {
    if (!isTouchDevice) {
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isTouchDevice) {
      setIsHovered(false);
    }
  };

  const handleClick = () => {
    if (isTouchDevice) {
      setIsHovered(!isHovered);
    }
  };
  return (
    <div
      data-meta="StudyFormatCardVioletV2"
      className={`overflow-hidden text-white`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick} // Додаємо обробник кліку
    >
      <div
        className={`
              relative
              min-h-fit
              lg:w-[400px]
              lg:h-[500px]
              w-[350px]
              h-[400px]
              transition-transform
              duration-[1000ms]
              ease-in-out
              transform-style-preserve-3d
              ${isHovered ? 'rotate-x-180' : ''}
              `}
      >
        <div
          className={`absolute inset-0 px-8 pt-8 ${
            color === 'violet' ? 'pb-16' : 'pb-4'
          } transition-opacity duration-[700ms] ease-in-out ${
            isHovered ? 'opacity-0' : 'opacity-100'
          } backface-hidden file-border-violet-lg `}
        >
          <div className={`pb-4 h-20 pt-2 sm:pt-0 border-b border-violet-300 mb-2 max-w-[350px]`}>
            <CustomRichText data={title} tag="div" className="text-xl font-bold" />
          </div>
          <ul className="list-disc pl-4">
            {list.map((item, index) => (
              <li key={index} className="">
                {typeof item === 'string' ? item : <CustomRichText data={item.item} tag="span" />}
              </li>
            ))}
          </ul>
        </div>
        <div
          className={`absolute inset-0 flex flex-col  px-8 sm:py-8 file-violet-lg backface-hidden rotate-x-180`}
        >
          <CustomRichText
            data={subtitle}
            tag="div"
            className="font-bold h-20 pt-2 sm:pt-0 border-b border-violet-300"
          />
          <CustomRichText data={txtContent} tag="div" className="text-sm mt-4" />
        </div>
      </div>
    </div>
  );
}
